import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type PossessionId = 'dog' | 'watch' | 'car' | 'house';

export interface Possession {
  id: PossessionId;
  label: string;
  description: string;
  sellPrice: number;
  available: boolean;        // false once sold
}

interface WalletStore {
  possessions: Possession[];
  ownsCharityFoundation: boolean;
  ownsYacht: boolean;
  ownsJet: boolean;
  ownsIsland: boolean;
  ownsSportsTeam: boolean;
  ownsNewspaper: boolean;
  sellPossession: (id: PossessionId) => Possession | undefined;
  acquireFoundation: () => void;
  acquireYacht: () => void;
  acquireJet: () => void;
  acquireIsland: () => void;
  acquireSportsTeam: () => void;
  acquireNewspaper: () => void;
}

const SEED_POSSESSIONS: Possession[] = [
  {
    id: 'dog',
    label: 'Bartholomew the dog',
    description: '12 lbs of unconditional love. Sells well, ruins your life.',
    sellPrice: 300,
    available: true,
  },
  {
    id: 'watch',
    label: 'Dad\'s Rolex',
    description: 'Heirloom. Pawnable. He will know.',
    sellPrice: 1_500,
    available: true,
  },
  {
    id: 'car',
    label: 'The car',
    description: '2019 sedan. Smells like vape. Liquid for the price.',
    sellPrice: 5_000,
    available: true,
  },
  {
    id: 'house',
    label: 'The house',
    description: '"Starter home." Mortgage included free of charge. Will move you to the office floor.',
    sellPrice: 50_000,
    available: true,
  },
];

export const useWallet = create<WalletStore>()(
  immer((set, get) => ({
    possessions: SEED_POSSESSIONS,
    ownsCharityFoundation: false,
    ownsYacht: false,
    ownsJet: false,
    ownsIsland: false,
    ownsSportsTeam: false,
    ownsNewspaper: false,
    sellPossession: (id) => {
      const p = get().possessions.find((x) => x.id === id);
      if (!p || !p.available) return undefined;
      set((s) => {
        const target = s.possessions.find((x) => x.id === id);
        if (target) target.available = false;
      });
      return p;
    },
    acquireFoundation: () => set((s) => { s.ownsCharityFoundation = true; }),
    acquireYacht: () => set((s) => { s.ownsYacht = true; }),
    acquireJet: () => set((s) => { s.ownsJet = true; }),
    acquireIsland: () => set((s) => { s.ownsIsland = true; }),
    acquireSportsTeam: () => set((s) => { s.ownsSportsTeam = true; }),
    acquireNewspaper: () => set((s) => { s.ownsNewspaper = true; }),
  })),
);
